// extracted by mini-css-extract-plugin
export default {"product-info-section":"LmN6oGJgEhPqIK4jtePi","section-title":"lknWlVBpJcbApyEVPbrF","divider-wrapper":"CHdsgjqyiZAtLQ8h4KQr"};